export default __webpack_public_path__ + "static/media/ic_polygon_16.b8612832.svg";